export default __webpack_public_path__ + "static/media/speakers__christina-moulton.3e3c48b0.jpg";